/**
 * §P.7 · Vuestro plan · `endpoints.md` §A.2.1
 *
 * Lo que el club tiene contratado con Kiap, cuánto lo usa y hasta cuándo está
 * pagado. Encima de los datos del club porque es lo primero que se busca cuando
 * llega el aviso de «ponte al día» o el de «os estáis quedando cortos».
 *
 * **Los límites no cortan nada**, y la tarjeta lo dice con esas palabras: un
 * «63 de 60» en rojo sin explicación haría pensar que el alumno 61 no se puede
 * dar de alta, y sí se puede.
 */
import { euros, fecha } from '@/shared/ui/formato';
import type { PlanDelClub } from '@/club/plan';

const cadaCuanto = (periodicidad: string): string =>
  periodicidad === 'annual'
    ? 'al año'
    : periodicidad === 'quarterly'
      ? 'al trimestre'
      : 'al mes';

function Uso({
  nombre,
  uso,
}: {
  nombre: string;
  uso: { used: number; max: number | null };
}) {
  const pasado = uso.max !== null && uso.used > uso.max;
  return (
    <div>
      <dt>{nombre}</dt>
      <dd className={pasado ? 'texto-mal' : ''}>
        {uso.max === null
          ? `${uso.used}, sin límite`
          : `${uso.used} de ${uso.max}`}
      </dd>
    </div>
  );
}

export function VuestroPlan({ plan }: { plan: PlanDelClub | undefined }) {
  if (!plan?.plan) return null;

  const { payment } = plan;

  return (
    <section className="tarjeta-plan">
      <h2 className="seccion">Vuestro plan con Kiap</h2>
      <dl className="datos">
        <div>
          <dt>Plan</dt>
          <dd>
            <strong>{plan.plan.name}</strong>
            {plan.plan.price_cents !== null && (
              <span className="tenue">
                {' '}
                · {euros(plan.plan.price_cents)}{' '}
                {cadaCuanto(plan.plan.billing_period)}
              </span>
            )}
          </dd>
        </div>
        <Uso nombre="Alumnos activos" uso={plan.usage.students} />
        <Uso nombre="Sedes" uso={plan.usage.venues} />
        <div>
          <dt>Pagado hasta</dt>
          <dd>{fecha(payment.paid_through)}</dd>
        </div>
      </dl>

      {plan.over_limit && (
        <p className="tenue">
          Os habéis pasado de los límites de vuestro plan.{' '}
          <strong>No se os ha cortado nada</strong> y podéis seguir dando altas;
          os escribiremos para ver si os conviene un plan mayor.
        </p>
      )}
    </section>
  );
}
